function ConditionalWrapper({ condition, className, children }) {
  if (condition) {
    return <div className={className}>{children}</div>;
  }
  return <>{children}</>;
}

export default ConditionalWrapper;
